var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaasImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 274.26 269.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dde1e6;opacity:0.5;}.cls-2{fill:#0f62fe;stroke:#0f62fe;}.cls-3{fill:url(#linear-gradient);}.cls-11,.cls-4,.cls-5,.cls-9{fill:none;}.cls-4{stroke:url(#linear-gradient-2);}.cls-5{stroke:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:#33b1ff;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{stroke:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{stroke:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 202.76,
    y1: 187.54,
    x2: 274.26,
    y2: 187.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c7cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 206.26,
    y1: 110.15,
    x2: 270.26,
    y2: 110.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 145.11,
    y1: 153.74,
    x2: 264.72,
    y2: 153.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 8.4,
    y1: 73.51,
    x2: 51.88,
    y2: 30.03,
    gradientTransform: "translate(160.84 59.28) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f62fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 187.54,
    x2: 71.5,
    y2: 187.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 4,
    y1: 110.15,
    x2: 68,
    y2: 110.15,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -121.99,
    y1: 510.53,
    x2: -90.39,
    y2: 478.93,
    gradientTransform: "matrix(-0.97, -0.26, 0.26, -0.97, -134.35, 621.56)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 35.86,
    y1: 225.14,
    x2: 107.36,
    y2: 225.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 116.65, -45.43)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "con-img") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.13,
    y: 21.54,
    width: 104,
    height: 104,
    transform: "translate(-11.84 118.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 202.76,
    y: 198.04,
    width: 71,
    height: 71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "274.26 223.54 238.26 223.54 238.26 222.54 273.26 222.54 273.26 152.54 202.76 152.54 202.76 151.54 274.26 151.54 274.26 223.54"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.26,
    cy: 110.15,
    r: 31.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "264.72 213.54 193.72 213.54 193.72 142.04 145.47 93.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.27,142a3.5,3.5,0,0,0-4.57-.32L115.51,86.46l-.71.71L170,142.36a3.5,3.5,0,1,0,5.28-.39ZM171,146.22a2.49,2.49,0,0,1-.32-3.15,2.88,2.88,0,0,1,.32-.39,3.79,3.79,0,0,1,.38-.32,2.5,2.5,0,1,1-.38,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M0,197.54H72v72H0v-72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "36 223.54 0 223.54 0 151.54 71.5 151.54 71.5 152.54 1 152.54 1 222.54 36 222.54 36 223.54"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 36,
    cy: 110.15,
    r: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100.23,209.72a3.5,3.5,0,0,0-3-3.46v-78h-1v78a3.5,3.5,0,1,0,4,3.46Zm-6,0a2.5,2.5,0,0,1,2-2.45,2.52,2.52,0,0,1,1,0,2.5,2.5,0,1,1-3,2.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "9.32 215.23 80.32 215.22 80.31 143.72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaasImg);
export default __webpack_public_path__ + "static/media/paas-img.40666e72d6db1cb5d208eb622e5094e0.svg";
export { ForwardRef as ReactComponent };